import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';

export type AvatarStatus = 'none' | 'available' | 'busy' | 'absent';
export type AvatarSize = 'mini' | 'small' | 'default' | 'bigger' | 'large' | 'huge';

@Component({
  selector: 'work-ui-avatar',
  standalone: true,
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  imports: [CommonModule],
})
export class AvatarComponent {
  public imgSrc = input<string | null>(null);
  public status = input<AvatarStatus>('none');
  public alt = input('');
  public size = input<AvatarSize>('default');
  public fullWidth = input(false);
  public square = input(false);
  public initials = input('');

  /** Ohne Bild immer der neutrale Platzhalter — für alle Mandanten gleich. */
  protected effectiveImgSrc = computed(() => this.imgSrc() || 'assets/svg/avatar-placeholder.svg');
}
